import { HintType } from '@hb/domain';
import { ButtonKey } from '@hb/modules/global/global.constants';
import { StoreService } from '@hb/services/store/store.service';
import { MortgageCalculationService } from '@hb/services/mortgage-calculation/mortgage-calculation.service';
import { AdditionalInfoComponent } from '@hb/modules/global/additional-info';

import { Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MortgageDetail } from '@ap/ap-interface-apix-hypotheken-berekening';
import { ApContentModule } from '@ap/content';
import { ApErrorModule } from '@ap/error';
import { ApSpinnerComponent } from '@ap/spinner';
import { ApAmountDisplayComponent } from '@ap/amounts';

@Component({
    selector: 'max-mortgage',
    templateUrl: './max-mortgage.component.html',
    styleUrls: ['./max-mortgage.component.scss'],
    standalone: true,
    imports: [CommonModule, ApContentModule, ApErrorModule, ApSpinnerComponent, ApAmountDisplayComponent, AdditionalInfoComponent]
})
export class MaxMortgageComponent {
    protected readonly mortgageCalculationService = inject(MortgageCalculationService);
    protected readonly storeService = inject(StoreService);

    protected readonly hintType = HintType;
    questionKeyGrossAmount: ButtonKey = ButtonKey.MORTGAGE_INCOME_GROSS_AMOUNT;
    questionKeyNetAmount: ButtonKey = ButtonKey.MORTGAGE_INCOME_NET_AMOUNT;

    @Input() mortgageDetails: MortgageDetail;
    @Input() set key(key) {
        if (key === ButtonKey.MORTGAGE_INCOME) {
            this.questionKeyGrossAmount = ButtonKey.MORTGAGE_INCOME_GROSS_AMOUNT;
            this.questionKeyNetAmount = ButtonKey.MORTGAGE_INCOME_NET_AMOUNT;
        } else {
            this.questionKeyGrossAmount = ButtonKey.EXPECTED_MORTGAGE_GROSS_AMOUNT;
            this.questionKeyNetAmount = ButtonKey.EXPECTED_MORTGAGE_NET_AMOUNT;
        }
    }
    @Input() showMonthlyAmounts: boolean;
    @Input() id: string;
}
